import React, { ReactNode } from 'react';

interface OperationalScreenProps {
  logoSrc: string;
  logoAlt: string;
  emoji: string;
  title: string;
  message: string;
  /** CTA opcional (botón o enlace) renderizado bajo el mensaje. */
  action?: ReactNode;
}

/**
 * Shell compartido de las pantallas operacionales full-viewport que sustituyen
 * al funnel (mantenimiento, config remota no disponible). Única fuente del
 * layout: fondo crema, logo, card blanca centrada con emoji + título + mensaje.
 */
export const OperationalScreen: React.FC<OperationalScreenProps> = ({
  logoSrc,
  logoAlt,
  emoji,
  title,
  message,
  action,
}) => (
  <div className="min-h-screen bg-[#F7F4EE] flex flex-col items-center justify-center px-6 py-12">
    <img src={logoSrc} alt={logoAlt} className="h-12 sm:h-14 object-contain mb-8" />
    <div className="bg-white rounded-[20px] shadow-sm p-8 sm:p-10 max-w-lg w-full text-center space-y-4">
      <div className="text-5xl mb-2">{emoji}</div>
      <h1 className="font-fredoka text-2xl sm:text-3xl font-bold text-[#008BBC] leading-snug">{title}</h1>
      <p className="font-fredoka text-base text-black/70 leading-relaxed">{message}</p>
      {action}
    </div>
  </div>
);
